import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker, NgbDateParserFormatter, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from 'app/shared/utils.service';

@Component({
  selector: 'cygov-datepicker-feature',
  templateUrl: './datepicker-feature.component.html',
  styleUrls: ['./datepicker-feature.component.scss'],
  standalone: false,
})
export class DatepickerFeatureComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() selectedDate: NgbDateStruct;
  // use this value for array of object, bec selectedDate uses as ngModel in datepicker and its automatically change array to single object
  @Input() selectedDatesArray: NgbDateStruct[];
  @Input() topPlaceholder: string = ''; // top placeholder with current month
  @Input() isCalendarDisabled = false; // Option to disable the calendar
  @Input() disableFullOpacity = false;
  @Input() dateToShow: NgbDateStruct | null = null; // To show date on top of calendar, only seen in non-toggle mode
  @Input() dateType: string; // An ID for the calendar
  @Input() displayName: string; // Name of calendar showing on top of calendar,only seen in non-toggle mode
  @Input() inputMaxDate: any | NgbDateStruct; // minimum selection date on calendar, not passing this value will not set the minDate
  @Input() inputMinDate: any | NgbDateStruct; // maximum selection date on calendar, not passing this value will not set the maxDate
  @Input() toggleButton = false; // Toggle the icon and mode.
  @Input() placeHolder = ''; // Placeholder to show on input field, only visible in Toggle Mode
  @Input() displayInputArea = false; // To display Input area of date picker
  @Input() openDefault = false;
  @Input() closeOnEmit = true;
  @Input() netskopeLabelDate = new Date();
  @Input() titleStatic: boolean = true;
  @Input() hideCloseIcon: boolean = false;
  // Trigger to return the new selected date if any
  @Output() selectedDateChange: EventEmitter<NgbDateStruct> = new EventEmitter<NgbDateStruct>();
  // Pass the calendar ref to parent - optional
  @Output() calendarRef: EventEmitter<NgbInputDatepicker> = new EventEmitter<NgbInputDatepicker>();
  // send boolean value when datepicker close by cross btn
  @Output() closingAlert: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('dateInput') dateCalendar: NgbInputDatepicker; // A reference to the calendar

  initialDateValue: NgbDateStruct;
  LabelMonthShow = {
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
    day: new Date().getDate(),
  };
  loaded = false;
  private timeouts: any[] = [];

  constructor(private parserFormatter: NgbDateParserFormatter) {}

  ngOnInit(): void {
    const dateValue: NgbDateStruct = Object.assign({}, this.inputMinDate as NgbDateStruct);
    delete dateValue.day;
    this.initialDateValue = dateValue;
  }

  ngAfterViewInit(): void {
    // emit the calendar ref access internal functions
    const timeoutId = setTimeout(() => {
      this.calendarRef.emit(this.dateCalendar);
      if (this.openDefault) {
        this.dateCalendar.open();
      }
      this.loaded = true;
    }, 100);
    this.timeouts.push(timeoutId);
  }

  dateUpdated(date): void {
    // emit the new date selected
    this.selectedDateChange.emit(date);
    if (this.closeOnEmit) {
      this.dateCalendar.close();
    }
  }

  calendarMonthNavigation(event, date: NgbDateStruct): void {
    date.month = event.next.month;
    date.year = event.next.year;
    const timeoutId = setTimeout(() => {
      this.netskopeLabelDate = JSON.parse(JSON.stringify(this.getDateinDateFormat(date)));
    }, 0);
    this.timeouts.push(timeoutId);
  }
  getDateinDateFormat(date: NgbDateStruct): Date {
    return new Date(date.year, date.month - 1, date.day);
  }
  ngOnChanges(): void {
    if (this.loaded && this.selectedDate) {
      // Manually changing the date to refresh the calendar
      const updatedDate = UtilsService.getShortDate(new Date(this.parserFormatter.format(this.selectedDate)));
      this.dateCalendar.manualDateChange(updatedDate, true);
    }
    // open/close datepicker on changing openDefault
    if (this.openDefault && this.dateCalendar) {
      this.dateCalendar.open();
    }
  }

  dateExistInCalendar(date: NgbDateStruct): boolean {
    if (this.selectedDatesArray && Array.isArray(this.selectedDatesArray)) {
      return this.selectedDatesArray.some(d => d.month === date.month && d.day === date.day && d.year === date.year);
    }
    return false;
  }

  // disable individual dates according to condition
  disableDates(dates: NgbDateStruct[]): any {
    // it is an hack for accomplishing disabledDates feature as 'this' is undefined here
    return (pickerDate: NgbDate) => {
      if (dates && Array.isArray(dates)) {
        // disable all dates except selectedDates as dates
        return !dates.some(d => d.month === pickerDate.month && d.day === pickerDate.day && d.year === pickerDate.year);
      }
      return false;
    };
  }

  closeDatePicker(): void {
    this.openDefault = false;
    this.closingAlert.emit(this.openDefault);
    this.dateCalendar.close();
  }

  ngOnDestroy(): void {
    // Clear all pending timeouts
    this.timeouts.forEach(timeoutId => clearTimeout(timeoutId));
  }
}
